export default [
  {
    path: '/batch/account-creation',
    name: 'batch-account-creation',
    component: () => import('@/views/pages/batch/AccountCreation.vue'),
    meta: {
      pageTitle: 'Batch Account Creation',
      hasPermission: 'BATCH_ACCOUNT_UPLOAD',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Account Creation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/batch-account-officer-reassign',
    name: 'batch-account-officer-reassign',
    component: () => import('@/views/pages/batch/BatchAccountOfficerReassign.vue'),
    meta: {
      pageTitle: 'Batch Account Officer Reassign',
      hasPermission: 'BATCH_ACCOUNT_OFFICER_REASSIGNMENT',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Account Officer Reassign',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/backdating-posting',
    name: 'batch-backdating-posting',
    component: () => import('@/views/pages/batch/BackdatingPosting.vue'),
    meta: {
      pageTitle: 'Batch Backdating Posting',
      hasPermission: 'VIEW_BATCH_BACKDATING_POSTING',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Backdating Posting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/loan-creation',
    name: 'batch-loan-creation',
    component: () => import('@/views/pages/batch/LoanCreation.vue'),
    meta: {
      pageTitle: 'Batch Loan Creation',
      hasPermission: 'BATCH_LOAN_UPLOAD',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Loan Creation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/loan-disburse',
    name: 'batch-loan-disburse',
    component: () => import('@/views/pages/batch/LoanDisburse.vue'),
    meta: {
      pageTitle: 'Batch Loan Disburse',
      hasPermission: 'VIEW_BATCH_LOAN_DISBURSE',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Loan Disburse',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/loan-termination',
    name: 'batch-loan-termination',
    component: () => import('@/views/pages/batch/BatchLoanTermination.vue'),
    meta: {
      pageTitle: 'Batch Loan Termination',
      hasPermission: 'REPAY_LOAN',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Loan Termination',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/gl-customer-posting',
    name: 'batch-gl-customer-posting',
    component: () => import('@/views/pages/batch/GLCustomerUploadPosting.vue'),
    meta: {
      pageTitle: 'Batch GL/Customer Upload Posting',
      hasPermission: 'VIEW_BATCH_GL_CUSTOMER_UPLOAD_POSTING',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch GL/Customer Upload Posting',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/batch-upload-posting-tracer',
    name: 'batch-upload-posting-tracer',
    component: () => import('@/views/pages/batch/BatchUploadPostingTracer.vue'),
    meta: {
      pageTitle: 'Batch Upload Posting Tracer',
      hasPermission: 'VIEW_BATCH_GL_CUSTOMER_UPLOAD_POSTING',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Upload Posting Tracer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch-account-status-update',
    name: 'batch-account-status-update',
    component: () => import('@/views/pages/batch/BatchAccountStatusUpdate.vue'),
    meta: {
      pageTitle: 'Batch Account Status Update',
      hasPermission: 'BATCH_ACCOUNT_UPDATE',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Account Status Update',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch-loan-schedule',
    name: 'batch-loan-schedule',
    component: () => import('@/views/pages/batch/BatchLoanScheduleEdit.vue'),
    meta: {
      pageTitle: 'Batch Loan Schedule',
      hasPermission: 'MODIFY_PAYMENT_SCHEDULE',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Loan Schedule',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/individual-customer',
    name: 'batch-individual-customer',
    component: () => import('@/views/pages/batch/IndividualCustomer.vue'),
    meta: {
      pageTitle: 'Batch Individual Customer',
      hasPermission: 'BATCH_ACCOUNT_UPLOAD',
      breadcrumb: [
        {
          text: 'Data Upload',
        },
        {
          text: 'Batch Individual Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/loan-account',
    name: 'loan-account',
    component: () => import('@/views/pages/batch/data-migrations/LoanAccount.vue'),
    meta: {
      pageTitle: 'Loan Account',
      hasPermission: 'BATCH_LOAN_UPLOAD',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Loan Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/gl-creation',
    name: 'gl-creation',
    component: () => import('@/views/pages/batch/data-migrations/GLCreation.vue'),
    meta: {
      pageTitle: 'GL Creation',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'GL Creation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/gl-balance',
    name: 'gl-balance',
    component: () => import('@/views/pages/batch/data-migrations/GLBalance.vue'),
    meta: {
      pageTitle: 'GL Balance',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'GL Balance',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/customer-balance',
    name: 'customer-balance',
    component: () => import('@/views/pages/batch/data-migrations/CustomerBalance.vue'),
    meta: {
      pageTitle: 'Customer Balance',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Customer Balance',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/loan-schedule',
    name: 'loan-schedule',
    component: () => import('@/views/pages/batch/data-migrations/LoanSchedule.vue'),
    meta: {
      pageTitle: 'Loan Schedule',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Loan Schedule',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/overdraft-account',
    name: 'overdraft-account',
    component: () => import('@/views/pages/batch/data-migrations/OverdraftAccount.vue'),
    meta: {
      pageTitle: 'Overdraft Account',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Overdraft Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/fixed-deposit-account',
    name: 'fixed-deposit-account',
    component: () => import('@/views/pages/batch/data-migrations/FixedDepositAccount.vue'),
    meta: {
      pageTitle: 'Fixed Deposit Account',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Fixed Deposit Account',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/individual-customer-creation',
    name: 'individual-customer-creation',
    component: () => import('@/views/pages/batch/data-migrations/IndividualCustomerAccountCreation.vue'),
    meta: {
      pageTitle: 'Individual Customer Account Creation',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Individual Customer Account Creation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/group-member-mapping',
    name: 'group-member-mapping',
    component: () => import('@/views/pages/batch/data-migrations/GroupMemberMapping.vue'),
    meta: {
      pageTitle: 'Group Member Mapping',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Group Member Mapping',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/group-customer-creation',
    name: 'group-customer-creation',
    component: () => import('@/views/pages/batch/data-migrations/GroupCustomerAccountCreation.vue'),
    meta: {
      pageTitle: 'Group Customer Account Creation',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Group Customer Account Creation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/batch/migration/corporate-customer-creation',
    name: 'corporate-customer-creation',
    component: () => import('@/views/pages/batch/data-migrations/CorporateCustomerAccountCreation.vue'),
    meta: {
      pageTitle: 'Corporate Customer Account Creation',
      hasPermission: 'DATA_MIGRATION',
      breadcrumb: [
        {
          text: 'Data Migration',
        },
        {
          text: 'Corporate Customer Account Creation',
          active: true,
        },
      ],
    },
  },
]
